import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email, regex } from 'vee-validate/dist/rules'

import router from './routes'

import './plugins/axios'
import './plugins/bus'
import './plugins/custom'
import './plugins/moment'

import Directives from './plugins/directives'

import Vue2TouchEvents from 'vue2-touch-events'
import VueAnalytics from 'vue-analytics'
import VueGTM from 'vue-gtm'
import VueCarousel from 'vue-carousel'
import infiniteScroll from 'vue-infinite-scroll'
import Meta from 'vue-meta'
import objectFitPolyfill from 'objectFitPolyfill'

import 'vuetify/src/stylus/app.styl'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader TODO: get this to only load on 1 page.
import './scss/app.scss'

// VeeValidate
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

extend('required', {
  ...required,
  message: 'The {_field_} is required.'
})

extend('fname', {
  ...required,
  message: 'Please enter your first name.'
})

extend('lname', {
  ...required,
  message: 'Please enter your last name.'
})

extend('location', {
  ...required,
  message: 'Please select a location.'
})

extend('email', {
  ...email,
  message: 'Please provide a valid email.'
})

extend('state', {
  ...required,
  message: 'Please select your state of residence.'
})

extend('phone', {
  ...required,
  message: 'Please enter your phone number.'
})

extend('regex', {
  ...regex,
  message: 'Please enter a valid phone number, following this format: 5554441234'
})

// Headful for meta-data
Vue.use(Meta)

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-3219619-2',
  require: ['displayfeatures']
})

// Google Tag Manager
Vue.use(VueGTM, {
  id: 'GTM-NT4J32',
  enabled: true,
  debug: false,
  vueRouter: router
})

// Vue Carousel
Vue.use(VueCarousel)

// Vue Infinite Scroll
Vue.use(infiniteScroll)

// Enable touch events
Vue.use(Vue2TouchEvents)

// Object Fit Polyfill
Vue.use(objectFitPolyfill)

Vue.use(Directives)

Vue.config.productionTip = false

const fixIdScrolling = {
  watch: {
    $route (to, from) {
      const currentRoute = this.$router.currentRoute
      const idToScrollTo = currentRoute.hash

      this.$nextTick(() => {
        if (idToScrollTo && idToScrollTo.indexOf('#!') === -1 && document.querySelector(idToScrollTo)) {
          window.addEventListener('load', () => {
            document.querySelector(idToScrollTo).scrollIntoView()
          })
        }
      })
    }
  }
}

new Vue({
  mixins: [fixIdScrolling],
  router,
  render: h => h(App)
}).$mount('#app')
